import { render, staticRenderFns } from "./InfoIcon.vue?vue&type=template&id=7d5a2fe1"
import script from "./InfoIcon.vue?vue&type=script&lang=js"
export * from "./InfoIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports